// Temporadas de precio: panel del anuncio, franja del calendario, Reglas del calendario
// y la acción «Temporada» del calendario en lote.
export const priceSeasons = {
  card: {
    title: "Temporadas",
    sub: "Sube o baja precios por fechas y por canal",
  },
  header: {
    eyebrow: "Precios por fechas",
    title: "Temporadas de precio",
    subtitle: "Sube o baja tus precios en las fechas que quieras, para todos los canales o solo para algunos. Abajo ves cuánto cobras cada día en cada canal.",
    new: "Nueva temporada",
  },
  notice: {
    preview: "Vista previa: las temporadas aún no cambian los precios que se venden ni lo que llega a las OTAs.",
  },
  states: {
    loading: "Cargando temporadas…",
  },
  year: {
    title: "Tu año de un vistazo",
    sub: "Cada color es una temporada. Pulsa un mes para ver sus precios.",
    prev: "Año anterior",
    next: "Año siguiente",
    jump: "Ver los precios de este mes",
    empty: "Este año aún no tiene temporadas.",
  },
  list: {
    title: "Tus temporadas",
    sub: "Qué hace cada una, cuándo y dónde.",
    emptyTitle: "Aún no tienes temporadas",
    emptyText: "Crea una para subir el precio en fechas de mucha demanda (verano, Navidad, un festival…) o bajarlo cuando hay poco movimiento.",
    createFirst: "Crear la primera",
    paused: "En pausa",
    pause: "Pausar",
    activate: "Activar",
    edit: "Editar",
    duplicate: "Duplicar",
    delete: "Borrar",
    noEffect: "Sin cambios de precio",
    everyYear: "cada año",
    rateFallback: "Tarifa",
    channelFallback: "Canal {id}",
  },
  chips: {
    all: "{value} todos los canales",
    fixed: "{price} por noche, todos los canales",
  },
  scope: {
    onlyThis: "Solo este calendario",
    shared: "Compartida · {count} calendarios",
    allCalendars: "Todos los calendarios ({count})",
    allRooms: "Todas las habitaciones ({count})",
    listing: "Este anuncio",
    listingHint: "Todos los apartamentos de este anuncio",
    otherListing: "Otro anuncio",
    units: "Solo estos alojamientos",
    unitsHint: "Elige en qué apartamentos se aplica",
    unitsCount: "1 alojamiento | {count} alojamientos",
    account: "Toda la cuenta",
    accountHint: "Todos tus anuncios y alojamientos",
  },
  calendar: {
    title: "Calendario de precios",
    sub: "El precio final de cada noche en cada canal. Pasa el ratón (o toca) una celda para ver cómo se calcula.",
    prev: "Mes anterior",
    next: "Mes siguiente",
    noUnits: "Este anuncio aún no tiene alojamientos con tarifa.",
    noRate: "No hemos encontrado la tarifa de este alojamiento.",
    loading: "Calculando precios…",
    legendUp: "Sube por temporada",
    legendDown: "Baja por temporada",
    legendManual: "Precio puesto a mano ese día",
    manualShort: "a mano",
    ratesIn: "Precios en {currency}",
    seasonRow: "Temporada",
    seasonTip: "Temporada: {name}",
    standard: "Tarifa Estándar",
    mainSub: "Tarifa principal",
    usualPct: "Recargo habitual {value}",
    ownPrice: "Precio propio",
  },
  rule: {
    show: "¿Cómo se calcula?",
    hide: "Ocultar explicación",
    title: "Así se calcula el precio de cada noche",
    step1: "Se parte del precio de ese día: el puesto a mano si lo hay; si no, el de fin de semana o el base.",
    step2: "Sobre ese precio se aplica la temporada de «todos los canales».",
    step3: "Cada canal aplica después su recargo de siempre (por ejemplo, Booking +21 %).",
    step4: "Por último, se suma la temporada de ese canal, si la hay.",
    overlap: "Si dos temporadas coinciden, manda la más concreta (la de fechas más cortas). «Todos los canales» y cada canal se deciden por separado.",
  },
  tip: {
    withoutSeason: "Sin temporada",
    base: "Base",
    dayPrice: "Precio del día",
    manual: "Puesto a mano",
    manualWins: "«{name}» no se aplica: el precio puesto a mano manda.",
    fixed: "precio fijo {price}",
  },
  editor: {
    nameTitle: "Nombre",
    subSpecial: "Un evento o unas fechas concretas con su propio precio.",
    saveChanges: "Guardar cambios",
    verbUp: "Sube",
    verbDown: "Baja",
    titleNew: "Nueva temporada especial",
    titleEdit: "Editar temporada",
    step1: "¿Cómo se llama?",
    step2: "¿Qué fechas?",
    step3: "¿Qué cambia?",
    step4: "Dónde se aplica",
    namePlaceholder: "Ej.: Festival de jazz",
    examplePh: "Ej.: {value}",
    from: "Desde",
    to: "Hasta",
    repeat: "Se repite cada año",
    removeRange: "Quitar estas fechas",
    addRange: "Añadir otras fechas",
    allChannels: "Para todos los canales",
    allChannelsHint: "Cambia el precio base; cada canal mantiene su recargo de siempre encima.",
    modeUp: "Subir %",
    modeDown: "Bajar %",
    modeAmount: "Sumar importe",
    modeFixed: "Precio fijo",
    hint_up: "Ej.: 20 → una noche de 100 pasa a 120.",
    hint_down: "Ej.: 10 → una noche de 100 pasa a 90.",
    hint_amount: "Se suma a cada noche. Usa un número negativo para restar.",
    hint_fixed: "Todas las noches de estas fechas cuestan esto, sea cual sea su precio.",
    someChannels: "Solo para algunos canales",
    someChannelsHint: "Un ajuste extra solo en esos canales. Usa un número negativo para bajar.",
    usual: "Recargo habitual {value}",
    channelAddsUp: "Se suma al recargo que ya tiene ese canal.",
    exampleLabel: "Ejemplo",
    exampleSame: "Una noche de {base} se queda en {base}",
    exampleChange: "Una noche de {base} pasa a {after}",
    exampleChannel: "en {channel} {price}",
    copyName: "{name} (copia)",
    cancel: "Cancelar",
    save: "Guardar temporada",
    saving: "Guardando…",
  },
  delete: {
    title: "¿Borrar «{name}»?",
    text: "Esas fechas vuelven a tener sus precios de siempre. No se puede deshacer.",
    confirm: "Sí, borrar",
  },
  errors: {
    periodName: "Ponle un nombre a cada periodo (por ejemplo, «Semana Santa»).",
    name: "Ponle un nombre para reconocerla.",
    ranges: "Indica la fecha de inicio y la de fin.",
    rangeOrder: "La fecha de fin no puede ser anterior a la de inicio.",
    value: "Escribe cuánto cambia el precio.",
    down: "Para bajar, usa un porcentaje menor que 100.",
    channelRange: "El ajuste por canal debe estar entre −100 % y +1000 %.",
    effect: "Elige qué cambia: para todos los canales o para alguno.",
    units: "Marca al menos un alojamiento.",
  },
  toast: {
    removedFrom: "Quitada de 1 calendario. | Quitada de {count} calendarios.",
    loadError: "No se pudieron cargar las temporadas.",
    saveError: "No se pudo guardar. Inténtalo de nuevo.",
    created: "Temporada creada.",
    updated: "Temporada guardada.",
    deleted: "Temporada borrada.",
    activated: "Temporada activada.",
    paused: "Temporada en pausa.",
  },
  calendarStripe: {
    tip: "Temporada: {name}",
    tipChannels: "Temporada: {name} (solo algunos canales)",
  },
  adm: {
    seeAll: "Ver las {n} temporadas",
    periods: "{n} periodos",
    next: "próximo: {dates}",
    same: "Mismo precio",
    closes: "Cierra",
    someRates: "Algunas tarifas",
    title: "Temporadas",
    summary: "1 temporada toca este alojamiento | {count} temporadas tocan este alojamiento",
    summaryNone: "Ninguna temporada de precio en este alojamiento",
    empty: "No hay temporadas que cambien el precio de este alojamiento.",
    manage: "Gestionar temporadas",
  },
  bulk: {
    label: "Temporada",
    hint: "Sube o baja el precio de estas fechas",
    microcopy: "Precio por fechas y canal",
    group: "Temporadas de precio",
    title: "¿Cómo es la temporada?",
    stepHint: "Se aplica a las fechas y alojamientos que has elegido arriba.",
    name: "Nombre",
    create: "Crear temporada",
    scopeAccount: "Se aplicará a toda la cuenta.",
    scopeUnits: "Se aplicará a 1 alojamiento. | Se aplicará a {count} alojamientos.",
    summaryAccount: "Temporada del {from} al {to} en toda la cuenta.",
    summaryUnits: "Temporada del {from} al {to} en 1 alojamiento. | Temporada del {from} al {to} en {count} alojamientos.",
  },
  // ── Rediseño: temporadas por nivel (alta, media, baja) y especiales ──
  tiers: {
    high: "Temporada alta",
    mid: "Temporada media",
    low: "Temporada baja",
    custom: "Temporada especial",
    highShort: "Alta",
    midShort: "Media",
    lowShort: "Baja",
    customShort: "Especial",
  },
  yourYear: {
    colSeason: "Temporada",
    colPeriods: "Periodos",
    colAdjust: "Ajuste",
    colActions: "Acciones",
    manage: "Gestionar",
    morePeriods: "+{count} más",
    exampleShort: "{base} → {after}",
    title: "Temporadas de tu año",
    sub: "Cuándo tienes más y menos demanda, y cuánto sube o baja el precio en cada momento.",
    basisFallback: "Según tus reservas y la demanda de tu zona",
    suggested: "Sugerida",
    active: "Activa",
    paused: "En pausa",
    occupancy: "Ocupación {value} %",
    occupancyUnknown: "Sin datos de ocupación aún",
    editDates: "Editar fechas",
    edit: "Editar",
    apply: "Aplicar temporadas",
    applying: "Aplicando…",
    applyHint: "Revisa los porcentajes antes de aplicar. Se aplican solo a este anuncio y puedes pausarlas cuando quieras.",
    applied: "Temporadas aplicadas.",
    allApplied: "Tus temporadas están aplicadas. Cambia el porcentaje cuando quieras: se guarda solo. Para cambiar fechas, pulsa «Gestionar».",
    noDates: "Sin fechas este año",
    raise: "Sube un {value} %",
    lower: "Baja un {value} %",
    same: "Mismo precio, solo marca el periodo",
    less: "Bajar 5 %",
    more: "Subir 5 %",
    example: "Una noche de {base} → {after}",
    otherAdjust: "Ajuste: {value}",
    saved: "Ajuste guardado.",
    noSuggestions: "Aún no hay suficientes datos para detectar tus temporadas. Puedes crearlas tú en «Temporadas especiales».",
  },
  special: {
    emptyShort: "Aún no tienes temporadas especiales.",
    addNew: "Nueva temporada especial",
    title: "Temporadas especiales",
    sub: "Festivales, eventos, puentes… fechas concretas con su propio precio.",
    add: "Añadir temporada",
    empty: "Aún no tienes temporadas especiales. Añade una para un evento o unas fechas concretas.",
  },
  yearLegend: {
    custom: "Especiales",
    suggested: "Sugerida, sin aplicar",
    dominant: "Predomina: {tier}",
  },
  editorType: {
    label: "Tipo de temporada",
    hint: "Alta, media y baja se ven con su color en todo el calendario. «Especial» es para eventos y fechas concretas.",
  },
  stripeTip: {
    standardPrice: "Tarifa Estándar: {from} → {to}",
    standardSame: "Tarifa Estándar: sin cambios",
    standardClosed: "Tarifa Estándar: cerrada",
    allChannelsSame: "Todos los canales: mismo precio",
    allChannels: "Todos los canales {value}",
    onlyIn: "Solo en: {channels}",
    previewNote: "Vista previa: aún no cambia el precio publicado",
    range: "{from} – {to}",
    noChange: "Sin cambio de precio",
    ratePrice: "{rate}: {from} → {to}",
    rateClosed: "{rate}: cerrada",
  },
  bulkType: {
    label: "Tipo",
  },
  tiersPlural: {
    high: "Temporadas altas",
    mid: "Temporadas medias",
    low: "Temporadas bajas",
  },
  manage: {
    high: "Gestionar temporadas altas",
    mid: "Gestionar temporadas medias",
    low: "Gestionar temporadas bajas",
    highSub: "Las fechas del año con más demanda. Añade un periodo por cada una: Semana Santa, verano, Navidad…",
    midSub: "Fechas con una demanda normal. Puedes dejar el mismo precio y usarlas solo para marcar el periodo.",
    lowSub: "Las fechas con menos movimiento, en las que conviene bajar el precio para atraer reservas.",
  },
  periods: {
    title: "Periodos",
    hint: "Cada periodo tiene un nombre y unas fechas. Por ejemplo: «Semana Santa», del 29 de marzo al 6 de abril.",
    generated: "Periodo {n}",
    noDates: "Sin fechas",
    name: "Nombre del periodo",
    namePh: "Ej.: Semana Santa",
    add: "Añadir periodo",
    remove: "Quitar",
    done: "Listo",
    empty: "Aún no hay periodos. Añade el primero.",
    showSuggestions: "Ver sugerencias",
    hideSuggestions: "Ocultar sugerencias",
    suggestionsHint: "Pulsa una para añadirla con su nombre y sus fechas. Luego puedes cambiarlas.",
  },
  price: {
    title: "Precio",
    up: "Sube",
    down: "Baja",
    sameShort: "Mismo precio",
    same: "En estas fechas el precio no cambia: la temporada solo marca el periodo.",
    sentenceUp: "En estas fechas, el precio sube",
    sentenceDown: "En estas fechas, el precio baja",
    sentenceAmount: "En estas fechas, a cada noche se le suma",
    sentenceFixed: "En estas fechas, cada noche cuesta",
    onlyChannels: "El precio base no cambia: solo se ajustan los canales elegidos en «Opciones avanzadas».",
  },
  advanced: {
    title: "Opciones avanzadas",
    sub: "Importe fijo, canales concretos y dónde se aplica",
    howTitle: "Cómo se ajusta el precio",
    percent: "Porcentaje",
  },
  holidays: {
    showPast: "Mostrar 1 fecha pasada | Mostrar {count} fechas pasadas",
    hidePast: "Ocultar fechas pasadas",
    title: "Festivos y eventos · {country} {year}",
    sub: "Fechas con más demanda en tu país. Aplica las que quieras como temporada especial, con el ajuste que elijas.",
    country: "País",
    colDate: "Fecha",
    colName: "Festivo o evento",
    colAdjust: "Ajuste",
    kindHoliday: "Festivo",
    kindBridge: "Puente",
    kindPeriod: "Temporada",
    highDemand: "Alta demanda",
    apply: "Aplicar",
    applied: "Aplicada",
    remove: "Quitar",
    applyHigh: "Aplicar los de alta demanda",
    bulkHint: "Queda 1 fecha de alta demanda sin aplicar. | Quedan {count} fechas de alta demanda sin aplicar.",
    appliedToast: "«{name}» aplicada como temporada especial.",
    appliedMany: "1 temporada especial creada. | {count} temporadas especiales creadas.",
    empty: "No hay festivos ni eventos para este país y año.",
    badge: "Festivo",
  },
  closures: {
    sectionTitle: "Cierres por temporada",
    sectionSub: "Fechas en las que dejas de vender, en todas las tarifas o solo en algunas.",
    empty: "No tienes fechas cerradas.",
    add: "Cerrar fechas",
    whatTitle: "¿Qué cierras?",
    namePh: "Ej.: Reformas del baño",
    titleNew: "Cerrar fechas",
    titleEdit: "Editar cierre",
    editorSub: "Elige las fechas y qué tarifas dejan de venderse. El precio no cambia.",
    title: "Cerrar la venta en estas fechas",
    hint: "Nadie podrá reservar estas noches en las tarifas que elijas. Puedes usarlo sin cambiar el precio.",
    all: "Todas las tarifas",
    some: "Solo algunas tarifas",
    allHint: "Se cierran todas las tarifas y todos los canales.",
    someHint: "Solo se cierran las tarifas marcadas; el resto sigue a la venta.",
    mainRate: "Tarifa principal ({name})",
    pickOne: "Marca al menos una tarifa para cerrar.",
    tagAll: "Cierra todo",
    tagSome: "Cierra: {rates}",
    closedShort: "Cerrada",
    closed: "Cerrada por una temporada",
    closedBy: "Cerrada por «{name}»",
    popupAll: "Venta cerrada: todas las tarifas",
    popupSome: "Cerrada: {rates}",
  },
  tierCount: {
    high: "temporada alta configurada | temporadas altas configuradas",
    mid: "temporada media configurada | temporadas medias configuradas",
    low: "temporada baja configurada | temporadas bajas configuradas",
  },
  tierCountSug: {
    high: "temporada alta sugerida | temporadas altas sugeridas",
    mid: "temporada media sugerida | temporadas medias sugeridas",
    low: "temporada baja sugerida | temporadas bajas sugeridas",
  },
  tierCard: {
    next: "Próxima",
    noneUpcoming: "No quedan periodos este año",
    preview: "Previsualizar",
    configure: "Configurar",
    close: "Cerrar",
    colPeriod: "Periodo",
  },
  picker: {
    fromEvent: "Elegir un festivo o evento",
    fromEventSub: "Fechas clave de {country}",
    manual: "Crear uno a mano",
    manualSub: "Tú pones el nombre y las fechas",
    search: "Buscar: Navidad, Carnaval…",
    countryLine: "Festivos y eventos de {country} · {year}",
    notYourCountry: "¿No es tu país? Cambiar",
    added: "Añadido",
    noResults: "No hay festivos que coincidan.",
  },
  rules: {
    title: "¿Qué cambia?",
    hint: "Una regla por cada cambio: a qué tarifas toca y qué les hace.",
    add: "Añadir regla",
    remove: "Quitar regla",
    empty: "Aún no hay reglas. Añade la primera.",
    whichRates: "¿A qué tarifas?",
    allRates: "Todas las tarifas",
    someRates: "Elegir tarifas",
    searchRates: "Buscar tarifa…",
    filterAll: "Todas",
    filterNone: "Sin canal",
    noRates: "No hay tarifas que coincidan.",
    whatToDo: "¿Qué hacemos?",
    actUp: "Subir %",
    actDown: "Bajar %",
    actAmount: "Sumar importe",
    actClose: "Cerrar la venta",
    value: "Valor",
    closeHint: "Esas tarifas no se podrán reservar en estas fechas.",
    incomplete: "Termina esta regla: elige tarifas, qué hacer y el valor.",
    principal: "Principal",
    derived: "Derivada",
    derivedFrom: "Derivada de {name}",
    usual: "recargo {value}",
    wholeChannel: "Todas las tarifas de este canal",
    channelAll: "{channel} · todas sus tarifas",
    noRateYet: "Sin tarifas elegidas",
    sumUp: "sube {value} %",
    sumDown: "baja {value} %",
    sumPlus: "suma {value}",
    sumMinus: "resta {value}",
    sumFixed: "cuesta {value}",
    sumClosed: "cerrada",
    sentenceUp: "El precio sube",
    sentenceDown: "El precio baja",
  },
  draft: {
    period: "Ver periodo:",
    see: "Ver cómo queda",
    back: "Volver a editar",
    apply: "Aplicar temporada",
    title: "Así quedaría",
    sub: "{apt}, del {from} al {to}. Todavía no se ha guardado nada.",
    noChanges: "Con estas reglas no cambia ningún precio en estas fechas.",
    up: "{n} noche sube | {n} noches suben",
    down: "{n} noche baja | {n} noches bajan",
    closed: "{n} noche cerrada | {n} noches cerradas",
    cellChange: "Antes {before} → ahora {after}",
    cellSame: "{price} (sin cambio)",
    cellClosed: "Cerrada (antes {before})",
    hoverHint: "Pasa el ratón por un precio para ver el antes y el después.",
    unavailable: "La vista previa aún no está disponible. Puedes aplicar la temporada igualmente.",
  },
  chart: {
    show: "Ver gráfico",
    hide: "Ocultar gráfico",
    title: "Precio por noche · {year}",
    titleDraft: "Precio por noche",
    rate: "Tarifa",
    base: "Precio base",
    current: "Actual",
    withSeason: "Con esta temporada",
    vsBase: "{value} frente al base",
    closed: "Cerrada",
    loading: "Cargando el año…",
    error: "No se pudo cargar el gráfico.",
    noSeason: "Sin temporada",
  },
  calendarCell: {
    before: "Antes {price} · {season}",
    closed: "Cerrada por la temporada «{season}»",
    closedShort: "Cerrada",
  },
  bulkStd: {
    note: "En la edición masiva la temporada se aplica a la tarifa Estándar de cada alojamiento (la del calendario). Para cambiar otras tarifas (Booking, No reembolsable…), usa «Temporadas» en la configuración del anuncio.",
  },
  legend: {
    button: "Temporadas",
    title: "Temporadas en el calendario",
    high: "Temporada alta",
    mid: "Temporada media",
    low: "Temporada baja",
    special: "Temporada especial o festivo",
    someRates: "Solo cambia algunas tarifas (no la Estándar)",
    up: "sube por temporada",
    down: "baja por temporada",
    hover: "Pasa el ratón por el precio o el punto para ver qué temporada es y cuánto cambia.",
  },
  target: {
    hintHotel: "Se ven todas las habitaciones del hotel; en cada temporada eliges a cuáles aplica.",
    rooms: "{count} tipo de habitación | {count} tipos de habitación",
    hint: "Cada calendario tiene sus propias temporadas.",
    label: "Estás configurando",
    labelHotel: "Hotel",
    search: "Buscar calendario…",
    count: "Sin temporadas | 1 temporada | {count} temporadas",
    none: "Ningún calendario coincide.",
  },
  where: {
    title: "En qué calendarios",
    titleHotel: "En qué tipos de habitación",
    hint: "Marca los calendarios que tienen esta temporada. Si desmarcas uno, deja de tenerla.",
    this: "este",
    all: "Marcar todos ({count})",
    onlyThis: "Solo este",
    onlyThisHotel: "Solo este hotel",
    allHotel: "Todo el hotel",
    noneHotel: "Quitar el hotel",
    account: "Esta temporada es de toda tu cuenta: se aplica también a tus otros anuncios.",
    errorNone: "Elige al menos un calendario.",
  },
  ask: {
    title: {
      change: "¿Dónde aplicar el cambio?",
      pause: "¿Dónde pausar «{name}»?",
      activate: "¿Dónde activar «{name}»?",
      delete: "¿De dónde quitar «{name}»?",
      create: "¿En qué calendarios crear las temporadas?",
    },
    text: "«{name}» la comparten {count} calendarios.",
    textNew: "Cada calendario tiene sus propias temporadas.",
    onlyThis: "Solo en «{name}»",
    onlyThisHint: "Los demás calendarios se quedan como están.",
    all: "En los {count} calendarios",
    removeThis: "Quitarla solo de «{name}»",
    removeThisHint: "Los demás calendarios la conservan.",
    removeAll: "Borrarla de los {count} calendarios",
    pick: "Elegir calendarios",
    pickHint: "Marca en cuáles.",
    confirm: "Aplicar",
  },
};
